import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  Vault,
  Register,
  Login,
  Feed,
  MyClaims,
  Contents,
  AddContent,
  AddClaim,
  Contact,
  Chats,
  Weather,
} from "./pages";
import "reactjs-popup/dist/index.css";
import "rc-slider/assets/index.css";
import Verification from "./pages/Verification";
import Projects from "./pages/Projects";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./redux/store";
import { ToastContainer } from "react-toastify";
import AuthRoute from "./HOC/AuthRoute";
import GuestRoute from "./HOC/GuestRoute";

const App = () => {
  return (
    <div className="text-black">
      <PersistGate loading={null} persistor={persistor}>
        <Routes>
          <Route element={<Verification />} path="/verification" />
          <Route element={<AuthRoute />}>
            <Route element={<Feed />} path="/feed" />
            <Route path="/" element={<Navigate replace to="feed" />} />
            <Route element={<Vault />} path="/vault" />
            <Route element={<Weather />} path="/weather" />
            <Route element={<Projects />} path="/projects" />
            <Route element={<Contact />} path="/contact" />
            <Route element={<Chats />} path="/chats" />
            <Route element={<Contents />} path="/contents" />
            <Route element={<AddContent />} path="/contents/addcontent" />
            <Route element={<Contents />} path="/contents" />
            <Route element={<MyClaims />} path="/claims" />
            <Route element={<AddClaim />} path="/claims/addclaim" />
          </Route>
          <Route element={<GuestRoute />}>
            <Route element={<Register />} path="/register" />
            <Route element={<Login />} path="/login" />
          </Route>
          <Route path={"*"} element={<NotFound />} />
        </Routes>
        <ToastContainer />
      </PersistGate>
    </div>
  );
};

const NotFound = () => {
  return (
    <>
      {" "}
      <div>You&apos;ve entered a black hole, find your way out</div>
    </>
  );
};
export default App;
